import React from 'react';
import classnames from 'classnames';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import {
  arrayOf, bool, shape, string, func
} from 'prop-types';
import DesktopContent from '../DesktopContent/DesktopContent';

export const RichContent = (props) => {
  // TODO: useEffect and useState, rich content type
  const {
    channel,
    description,
    documents,
    hideRichContents,
    preview,
    richContent,
    richContentsOnlyRef,
    setShouldShowMore,
    showRichContentsOnly,
    shouldShowMore,
    bullets,
    itemId,
    revJet
  } = props;

  const hasContent = showRichContentsOnly && (richContent || bullets.length);
  const shouldShowMoreClasses = classnames('rich-content__show-more', {
    'rich-content__show-more--display': !shouldShowMore
  });
  return (
    hasContent && (
      <div
        id="product_richcontent"
        className="grid pip-row section rich-content-wrapper"
        data-section="product-overview"
        ref={richContentsOnlyRef}
      >
        <Row>
          <Heading title="From the Manufacturer" />
          <Col>
            <DesktopContent
              itemId={itemId}
              description={description}
              documents={documents}
              richContent={richContent}
              revJet={revJet}
              bullets={bullets}
              hideRichContents={hideRichContents}
              preview={preview}
              showRichContentsOnly={showRichContentsOnly}
              shouldShowMore={shouldShowMore}
              channel={channel}
            />
          </Col>
          <div className={shouldShowMoreClasses} data-testid="should-show-more-element">
            <div className="rich-content__show-more-gradient" />
            <div className="rich-content__show-more-information">
              <button type="button" onClick={() => setShouldShowMore({ shouldShowMore: false })}>
                Show More
              </button>
            </div>
          </div>
        </Row>
      </div>
    )
  );
};

RichContent.displayName = 'RichContent';

RichContent.propTypes = {
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  hideRichContents: bool,
  preview: bool,
  richContentsOnlyRef: shape({}).isRequired,
  richContent: shape({}),
  setShouldShowMore: func,
  bullets: arrayOf(shape({})),
  shouldShowMore: bool,
  showRichContentsOnly: bool,
  revJet: bool,
  itemId: string.isRequired
};
RichContent.defaultProps = {
  hideRichContents: false,
  preview: false,
  richContent: {},
  setShouldShowMore: () => { },
  shouldShowMore: false,
  showRichContentsOnly: false,
  bullets: [],
  revJet: false
};
